var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.OrganismButtonsRow,{attrs:{"buttons":_setup.buttons,"selected":_setup.selected}})
}
var staticRenderFns = []

export { render, staticRenderFns }